/**
 * Determine the mobile operating system.
 *
 * @returns {{isIos: boolean, isAndroid:boolean}}
 */
export const checkMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  const isIos = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  const isAndroid = /android/i.test(userAgent) && !/windows phone/i.test(userAgent);
  const isSafari = !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
  const isIphone = !!navigator.userAgent.match(/\(iPhone/);
  const isTablet =
    /ipad|tablet/i.test(userAgent) ||
    /((android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/i.test(
      userAgent,
    );
  const isMobile = !isTablet && (isIphone || isAndroid);

  return {
    isIos,
    isAndroid,
    isSafari,
    isIphone,
    isTablet,
    isMobile,
  };
};
